export default "__VITE_ASSET__xJcZYdS3__"